import moduleDescriptions from 'root/src/shared/descriptions/modules'

import {
	bannerHeaderModuleDescriptionLenses,
} from 'root/src/client/logic/header/lenses'

const { viewFiltersRoute } = bannerHeaderModuleDescriptionLenses

export default (state, { moduleId }) => viewFiltersRoute(
	moduleId, moduleDescriptions,
)
